// AB ADDED
import React from 'react';
import { Alert } from '@mui/material';

/**
 * Renders a Material UI Alert with configurable severity.
 * @param {string} severity - one of: 'error', 'warning', 'info', 'success'
 * @param {ReactNode} children - content to display inside the alert
 */
const SeverityMessage = ({ severity = 'info', children, ...props }) => {
  if (!['error', 'warning', 'info', 'success'].includes(severity)) return null;

  return (
    <Alert severity={severity} variant="outlined" {...props}>
      {children}
    </Alert>
  );
};

export default SeverityMessage;
